import { Outlet, ScrollRestoration } from 'react-router-dom';

import { Footer } from './Footer';
import { Header } from './Header';

export function RootLayout(): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col bg-brand-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ScrollRestoration />
    </div>
  );
}
